import * as React from "react";

import classNames from "classnames";

interface DocRatingBarProps extends RatingBarNode, EveryNodeArgs {}

export default function DocRatingBar(props: DocRatingBarProps) {
  const {
    currentUser,
    inactiveBoolean,
    maxValue = 5,
    uid,
    value = 0,
  } = props;

  const stars = [...Array(5).keys()].map((i) => (
    <span
      className={classNames("doc-rating-bar-star", {"doc-rating-bar-star-active": i >= maxValue - value})}
      key={i}
      onClick={(e) => {
        e.stopPropagation();

        if (inactiveBoolean) {return null;}

        currentUser.addState({[uid]: {"value": maxValue - i}});
      }}
    >
      ☆
    </span>
  ));

  return (
    <div className={classNames("doc-rating-bar", {"inactive": inactiveBoolean})}>
      {stars}
    </div>
  );
}
